module.exports = __webpack_public_path__ + "static/media/Digital-Price-Tag-Three-Vertical.9a12eeec.jpg";